import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import ProductCard from './ProductCard';

export default function ProductSlider({ 
  title, 
  products = [], 
  loading = false,
  buttonText, 
  buttonLink, 
  perPage = 8
}) {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    const maxSlides = Math.ceil(products.length / 5) - 1;
    setCurrentSlide(prev => prev < maxSlides ? prev + 1 : 0);
  };

  const prevSlide = () => {
    const maxSlides = Math.ceil(products.length / 5) - 1;
    setCurrentSlide(prev => prev > 0 ? prev - 1 : maxSlides);
  };

  const getVisibleProducts = () => {
    const startIndex = currentSlide * 5;
    return products.slice(startIndex, startIndex + 5);
  };

  if (loading) {
    return (
      <section className="py-10 bg-black">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2" style={{ fontFamily: 'serif' }}>
              {title}
            </h2>
          </div>
          <div className="w-full">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
              {[...Array(5)].map((_, index) => (
                <div key={index} className="bg-gray-800 rounded-xl overflow-hidden animate-pulse flex flex-col">
                  <div className="bg-gray-700 flex-1" style={{ height: '250px' }}></div>
                  <div className="p-3 bg-gray-800 flex-shrink-0" style={{ minHeight: '80px' }}>
                    <div className="space-y-2">
                      <div className="bg-gray-700 h-4 rounded w-3/4"></div>
                      <div className="bg-gray-700 h-5 rounded w-1/2"></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (products.length === 0) {
    return (
      <section className="py-10 bg-black">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2" style={{ fontFamily: 'serif' }}>
              {title}
            </h2>
          </div>
          <div className="text-center py-8">
            <p className="text-gray-400 text-sm">No products available at the moment.</p>
          </div>
        </div>
      </section>
    );
  }

  const visibleProducts = getVisibleProducts();
  const maxSlides = Math.ceil(products.length / 5);

  return (
    <section className="py-10 bg-black">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-2" style={{ fontFamily: 'serif' }}>
            {title}
          </h2>
        </div>

        <div className="relative">
          {/* Slider Container */}
          <div className="overflow-hidden">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 transition-transform duration-500 ease-in-out">
              {visibleProducts.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          </div>

          {/* Navigation Arrows */}
          {maxSlides > 1 && (
            <>
              <button
                onClick={prevSlide}
                className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-2 rounded-full transition-all duration-300 hover:scale-110"
                style={{ backgroundColor: '#CF0F63' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#B00D56'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#CF0F63'}
              >
                <FiChevronLeft size={18} />
              </button>
              
              <button
                onClick={nextSlide}
                className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-2 rounded-full transition-all duration-300 hover:scale-110"
                style={{ backgroundColor: '#CF0F63' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#B00D56'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#CF0F63'}
              >
                <FiChevronRight size={18} />
              </button>
            </>
          )}

          {/* Dots Indicator */}
          {maxSlides > 1 && (
            <div className="flex justify-center mt-4 space-x-2">
              {Array.from({ length: maxSlides }).map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 ${
                    index === currentSlide 
                      ? 'bg-pink-500 scale-125' 
                      : 'bg-gray-600 hover:bg-gray-400'
                  }`}
                />
              ))}
            </div>
          )}
        </div>

      </div>
    </section>
  );
}
